"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _FoxIconErrorSolid = _interopRequireDefault(require("../foxIcons/FoxIconErrorSolid"));
var _index = require("./index");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-nested-ternary */

function size2px(size) {
  if (size == undefined) return 'auto';
  if (Number.isNaN(size)) return '0px';
  return "".concat(size, "px");
}
var prefix = "ui-".concat(new Date().getTime().toString());
var uid = 0;
function FoxModalUidCreator() {
  return "".concat(prefix, "-").concat(++uid);
}
function isFoxModalProps(props) {
  return 'size' in props;
}
function FoxModal(rest) {
  var _useState = (0, _react.useState)(function () {
      return FoxModalUidCreator();
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    queryWrapperClass = _useState2[0];
  var size = rest.size,
    closeIcon = rest.closeIcon,
    floatCloseIcon = rest.floatCloseIcon,
    height = rest.height,
    style = rest.style,
    children = rest.children,
    customizePrefixCls = rest.prefixCls,
    maskStyle = rest.maskStyle,
    modalRender = rest.modalRender,
    centered = rest.centered,
    title = rest.title,
    onCancel = rest.onCancel,
    closable = rest.closable,
    props = __rest(rest, ["size", "closeIcon", "floatCloseIcon", "height", "style", "children", "prefixCls", "maskStyle", "modalRender", "centered", "title", "onCancel", "closable"]);
  var isPopoverHeader = false;
  if (/*#__PURE__*/_react["default"].isValidElement(title)) {
    var fn = title.type;
    if (((0, _typeof2["default"])(fn) === 'object' && fn !== null || typeof fn === 'function') && 'symbol' in fn && fn.symbol === 'popover-header') {
      isPopoverHeader = true;
    }
  }
  if (isPopoverHeader) {
    floatCloseIcon = false;
  }
  var isFullScreen = size === 'fullScreen';
  var modalExtendsProps = function () {
    var modalHeight = function () {
      if (isFullScreen || height === 'fullScreen') return 'max(calc(100vh - 60px), 640px)';
      return size2px(height);
    }();
    var modalMaxHeight = function () {
      if (isFullScreen || height === 'fullScreen' || height === undefined) {
        return 'max(calc(100vh - 60px), 640px)';
      }
      return "min(calc(100vh - 60px), ".concat(size2px(height), ")");
    }();
    var widthProps = function () {
      if (isFullScreen) {
        return {
          width: "calc(100vw - 60px)",
          maxWidth: 960
        };
      }
      if ((0, _typeof2["default"])(size) === 'object') {
        return {
          width: "calc(100vw - 60px)",
          maxWidth: size2px(size.max),
          minWidth: size2px(size.min)
        };
      }
      return {
        width: size2px(size)
      };
    }();
    var foxModalMaskStyle = isFullScreen ? (0, _extends2["default"])((0, _extends2["default"])({}, maskStyle), {
      opacity: 0.9
    }) : maskStyle;
    var isSmallSize = function () {
      if (typeof size === 'string') return size !== '400';
      if (typeof size === 'number') return size > 400;
      return true;
    }();
    return (0, _extends2["default"])((0, _extends2["default"])({
      centered: centered || isSmallSize,
      mask: isSmallSize
    }, widthProps), {
      height: modalHeight,
      style: (0, _extends2["default"])((0, _extends2["default"])((0, _extends2["default"])({}, style), {
        '--ui-fox-modal-max-height': modalMaxHeight
      }), isPopoverHeader ? {
        '--ui-modal-header-padding': '0px'
      } : {}),
      maskStyle: foxModalMaskStyle
    });
  }();
  var modalRenderRef = (0, _react.useRef)(modalRender);
  modalRenderRef.current = modalRender;
  var innerModalRender = (0, _react.useCallback)(function (contentNode) {
    var content = contentNode;
    if (floatCloseIcon) {
      content = /*#__PURE__*/_react["default"].cloneElement(contentNode, {
        className: (0, _classnames["default"])('ui-fox-modal-float-close-icon', contentNode.props.className)
      });
    }
    return modalRenderRef.current ? modalRenderRef.current(content) : content;
  }, [floatCloseIcon]);
  return /*#__PURE__*/_react["default"].createElement(_index.Modal, (0, _extends2["default"])({}, props, modalExtendsProps, {
    title: title,
    prefixCls: customizePrefixCls,
    className: (0, _classnames["default"])(queryWrapperClass, size !== undefined && 'ui-fox-modal',
    // 当有设置size时候才是 fox modal
    size === 'fullScreen' ? 'ui-fox-modal-full-screen' : '', props.className, !isPopoverHeader ? 'ui-fox-modal-inner-header' : ''),
    closable: isPopoverHeader ? false : closable,
    closeIcon: isPopoverHeader ? null : closeIcon || (floatCloseIcon ? /*#__PURE__*/_react["default"].createElement(_FoxIconErrorSolid["default"], {
      size: 24
    }) : undefined),
    onCancel: onCancel,
    modalRender: innerModalRender
  }), children);
}
function FoxModalEntry(rest) {
  if (!isFoxModalProps(rest)) {
    return /*#__PURE__*/_react["default"].createElement(_index.Modal, rest);
  }
  return /*#__PURE__*/_react["default"].createElement(FoxModal, rest);
}
var _default = exports["default"] = FoxModalEntry;